import React, { useState, useRef } from 'react';
import FileSelector from '../../../common/FileSelector';
import Button from '../../../common/Button/Button';
import styles from './scss/no-files-uploaded.scss';
import UblcsModal from '../../../common/Ublcs-modal';

function NoFilesUploaded(props){
    const fileSelector = useRef();
    const [ublcsModal, toggleUblcsModal] = useState(false)

    const validMimeType = [
		'application/pdf','image/png', 'image/jpeg', 'image/jpg', 'image/webp'
    ]

	const validExtensions = [
		".pdf",".png",".jpg",".webp"
	]
    const accept = [
		...validMimeType,
		...validExtensions
	]
    const defaultMessage = ['Upload upto 5 files of 25 MB each.', 'Supported formats are Images, PDF and Microsoft Office Documents.']
   
    const ublcsModalHandler  = () => {
        toggleUblcsModal(true)
    }
   
    return(
    <div className={styles['no-files-uploaded']}>
        <div className={styles['image-wrapper']}>
             <img src={'https://image1.jdomni.in/jdomni_email/Attachment_graphic_2004031122.png'} /> 
        </div>
        <div className={styles['title']}>Select File to Upload</div>
        {props.message?.length ? props.message.map((message, i) => {
            if (props.isRenderHtml) {
                return (
                    <div className={styles['info-msg']} key={'10' + i * 19} dangerouslySetInnerHTML={{ __html: message }} />
                )
            } else {
                return (
                    <div className={styles['info-msg']} key={'10' + i * 19}>{message}</div>
                )
            }
        }) : defaultMessage.map((message, i) => 
        <div className={styles['info-msg']} key={'10' + i*19}>{message}</div>)}
        {!props.hideButton ?
        <div className={styles['upload-file-btn-wrapper']}>
            <Button size='lg' className={styles['upload-file-btn']} 
            clickHandler={() => { 
                if (props.isReadOnly) return ublcsModalHandler();
                props.onClick && props.onClick(); 
                if(props.onFileChange){
                    
                    fileSelector.current.triggerClick(props.isBrochure ? true : false);
                }
            }}>
                Upload File
            </Button>
        </div>
        : null }
        <FileSelector
            accept={accept.join()}
            onChange={(fileData) => {
                props.onFileChange(fileData);
            }}
            ref={fileSelector}
            />
            
        {ublcsModal ? 
            <UblcsModal 
                onHidden= {() => toggleUblcsModal(false)
            }
        /> : null}
    </div>
   );

}

export default NoFilesUploaded;